/**
 * carousel-groups.js
 * 
 * Synchronisiert zwei Carousels innerhalb einer Gruppe.
 * Gruppen werden durch CSS Klassen definiert:
 * 
 * - carousel-group und
 * - carousel-group-[id]
 * 
 * Beispiel:
 * 
 * <div class="carousel carousel-group carousel-group-home">...</div>
 * 
 * @author jjarolim
 * @ai
 */

const $ = window.jQuery; // Use global WP jQuery instance

const getGroupIdsFromCarouselEl = (el) => {
    return Array.from(el.classList)
        .filter((c) => c.startsWith("carousel-group-") && c !== "carousel-group")
        .map((c) => c.replace("carousel-group-", ""));
};

const connectTwoCarousels = ($a, $b, groupId = "unknown") => {
    let apiA = null;
    let apiB = null;

    let syncingFromA = false;
    let syncingFromB = false;
    let isBound = false;

    const elLabel = ($el, fallback) => {
        const id = $el.attr("id");
        const cls = ($el.attr("class") || "")
            .split(/\s+/)
            .filter(Boolean)
            .slice(0, 6)
            .join(".");
        return id ? `#${id}` : `${fallback}${cls ? "." + cls : ""}`;
    };

    const labelA = elLabel($a, "A");
    const labelB = elLabel($b, "B");

    const clampIndex = (api, index) => {
        const len = api.scrollSnapList().length;
        const clamped = Math.max(0, Math.min(index, len - 1));
        return clamped;
    };

    const bindIfReady = () => {
        if (!apiA || !apiB) {
            return;
        }

        if (isBound) {
            return;
        }

        isBound = true;

        // Initial sync (B folgt A)
        const target = clampIndex(apiB, apiA.selectedScrollSnap());
        apiB.scrollTo(target);

        apiA.on("select", () => {
            const fromIndex = apiA.selectedScrollSnap();
            if (syncingFromB) {
                return;
            }
            syncingFromA = true;
            const toIndex = clampIndex(apiB, fromIndex);
            apiB.scrollTo(toIndex);
            syncingFromA = false;
        });

        apiB.on("select", () => {
            const fromIndex = apiB.selectedScrollSnap();
            if (syncingFromA) {
                return;
            }
            syncingFromB = true;
            const toIndex = clampIndex(apiA, fromIndex);
            apiA.scrollTo(toIndex);
            syncingFromB = false;
        });

        // Optional: nach responsive reInit wieder angleichen
        apiA.on("reInit", () => {
            const toIndex = clampIndex(apiB, apiA.selectedScrollSnap());
            apiB.scrollTo(toIndex);
        });

        apiB.on("reInit", () => {
            const toIndex = clampIndex(apiA, apiB.selectedScrollSnap());
            apiA.scrollTo(toIndex);
        });
    };

    $a.on("carousel:getApi", (e, emblaApi) => {
        apiA = emblaApi;
        bindIfReady();
    });

    $b.on("carousel:getApi", (e, emblaApi) => {
        apiB = emblaApi;
        bindIfReady();
    });

    $a.trigger("carousel:requestApi");
    $b.trigger("carousel:requestApi");
};

const connectAllCarouselGroupsOnPage = () => {
    const groups = new Map(); // groupId -> [ $carousel, $carousel, ... ]

    $(".carousel-group").each(function () {

        const groupIds = getGroupIdsFromCarouselEl(this);

        // IMPORTANT:
        // The Embla API is attached to the inner `.carousel` element (see `carousel.js`),
        // while `carousel-group-*` might be placed on a wrapper block element.
        const $carouselEl = $(this).hasClass("carousel")
            ? $(this)
            : $(this).find(".carousel").eq(0);

        if (!$carouselEl.length) return;

        groupIds.forEach((groupId) => {
            if (!groups.has(groupId)) groups.set(groupId, []);
            groups.get(groupId).push($carouselEl);
        });
    });
    
    groups.forEach(($els, groupId) => {
        // Erwartung: genau 2 Carousels pro Gruppe
        if ($els.length !== 2) {
            return;
        }
        connectTwoCarousels($els[0], $els[1], groupId);
    });
};

const init = () => {
    // Warten bis `carousel.js` fertig initialisiert hat
    $(window).on("carousel:initialized", connectAllCarouselGroupsOnPage);
};

export { init };